import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';

const NAV_LINKS = [
  { to: '/', label: '首页' },
  { to: '/category', label: '全部漫画' },
  { to: '/ranking', label: '排行榜' },
  { to: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const onSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/category?q=${encodeURIComponent(q)}` : '/category');
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/90 backdrop-blur-md shadow-[0_6px_24px_-14px_oklch(var(--primary-500)/0.5)]'
          : 'bg-background-50'
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 h-16 md:h-[72px]">
        <div className="flex items-center gap-2 md:gap-3">
          <Link to="/" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-flower-fill text-lg" />
            </span>
            <span className="font-display text-xl md:text-2xl font-bold text-primary-600">
              桃花漫画网
            </span>
          </Link>
        </div>

        <div className="hidden items-center gap-7 md:flex">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive
                    ? 'text-primary-600'
                    : 'text-foreground-600 hover:text-primary-500'
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden items-center gap-3 lg:flex">
          <form
            onSubmit={onSearch}
            className="flex items-center gap-2 rounded-full border border-background-200 bg-background-100/70 px-3 py-1.5"
          >
            <i className="ri-search-line text-sm text-foreground-400" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索想看的漫画…"
              className="w-44 bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
            />
          </form>
          <Link
            to="/category"
            className="whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            开始阅读
          </Link>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-700 md:hidden"
          aria-label="打开菜单"
        >
          <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <div className="flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) =>
                  `rounded-lg px-3 py-2.5 text-sm font-medium ${
                    isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
          <form onSubmit={onSearch} className="mt-3 flex items-center gap-2 rounded-full border border-background-200 bg-background-100/70 px-3 py-2">
            <i className="ri-search-line text-sm text-foreground-400" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索想看的漫画…"
              className="flex-1 bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
            />
          </form>
        </div>
      )}
    </header>
  );
}